var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", {
      directives: [
        {
          name: "wechat-title",
          rawName: "v-wechat-title",
          value: _vm.$route.meta.title,
          expression: "$route.meta.title"
        }
      ]
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "app-container" },
      _vm._l(_vm.listData, function(item, index) {
        return _c(
          "div",
          { key: index, staticClass: "list" },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n                " +
                  _vm._s(item.question) +
                  "\n                "
              ),
              _c("i", [_vm._v(_vm._s(index + 1))])
            ]),
            _vm._v(" "),
            _vm._l(item.answer, function(item, index) {
              return _c("div", {
                key: index,
                staticClass: "content",
                domProps: { innerHTML: _vm._s(item) }
              })
            })
          ],
          2
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d8df916", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d8df916","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Question.vue
// module id = null
// module chunks = 